import { defineComponent, type MaybeRef, computed, unref } from 'vue'
import type { IProviderImportStepProps } from '../../types/stepProps'
import BreadcrumbStepper from 'components/stepper/breadcrumb'
import { popModal } from 'components/modal/store'
import { useResponsive } from '~/composables/useResponsive'

export const ProviderImportCrumbs = defineComponent<
  IProviderImportStepProps & {
    stepIndex: MaybeRef<number>
    titles: MaybeRef<string[]>;
    crumbs?: MaybeRef<boolean>;
    title?: MaybeRef<string>;
  }
>(
  (props) => {
    const responsive = useResponsive();
    const titles = computed(() => unref(props.titles) || [])
    const currentIndex = computed(() => unref(props.stepIndex) ?? 0);
    const showCrumbs = computed(() => unref(props.crumbs) !== false);
    const title = computed(() => {
      if (unref(props.title)) return unref(props.title);
      return responsive.isSmall.value ? 'Connect' : 'Connect Account';
    });

    return () => {
      return (
        <div class="w-full shrink-0 flex flex-row items-center justify-between p-4 md:p-5 border-b border-gray-300 text-lg font-semibold">
          <h2 class="md:text-xl flex-0 mr-2 md:flex-1 md:mr-0 text-gray-900">{title.value}</h2>
          {
            showCrumbs.value && <BreadcrumbStepper steps={titles.value} activeStep={currentIndex.value} />
          }
          <div class="flex flex-1 flex-row justify-end text-gray-800">
            <button
              onClick={() => {
                props.hook.cancel()
                popModal()
              }}
              type="button"
              class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
              data-modal-hide="default-modal"
            >
              <svg
                class="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
            </button>
          </div>
        </div>
      )
    }
  },
  { props: ['hook', 'titles', 'stepIndex', 'crumbs', 'title'] }
)
